export default __webpack_public_path__ + "static/media/cvod-RP16.1b4f9ffe.svg";